import { jsonConverter } from '~/Scene/Tool/Json';
import { canvasInteraction } from '~/Services/Studio/Canvas/canvasInteraction';
import {
    _contentsManager, _system, _environment, _pipeline, _camera, _mouseCatcher, _pointofviewsManager
} from './studioScene';
import { checkVisibleSky } from '~/Services/Studio/Plugins/environment';
import { contextProject } from '~/Context/contextProject';
import { LOCAL_JSON } from '~/Services/Environment/devConfig';
import env from '../Environment/environment';
import { IContentOptions } from '~/Scene/Content/content';
import { ContentLight } from '~/Scene/Content/contentLight';
import { ContentAnimation } from '~/Scene/Content/contentAnimation';
import { ContentModel } from '~/Scene/Content/contentModel';

const loadFinish = (callback: (result: boolean) => void) => {
    // contentEventManager.showAnimation(true);
    // contentEventManager.showLights();
    _contentsManager.showContents();
    _contentsManager.showDecals(false);
    _mouseCatcher.start();
    canvasInteraction.setFreeMode();
    _environment.resetShadowGroundHeight();

    //! Dirty fix but otherwise sky is visible
    checkVisibleSky();
    _system.startRender();
    setTimeout(() => {
        callback(true);
    }, 200);
};

const startRender = (callback: (result: boolean) => void) => {
    // Set Camera before launchRender
    // It will avoid a flash when canvas become visible
    _system.updateSize();
    _system.launchRender(() => {
        loadFinish(callback);
    });
};

export const getModels = () => _contentsManager.getContentModels();

export const getLights = () => _contentsManager.getContentLights();

const CONTENTS_TYPE = ['model', 'light'];

export const addContent = (
    content: IContentOptions, typedata: any
): ContentAnimation | ContentLight | ContentModel => {
    const { type, tag } = content;
    if (CONTENTS_TYPE.indexOf(type) === -1) return null;
    if (!tag) {
        if (type === 'light') {
            const nbLights = getLights().length + 1;
            const tag = `${type} ${nbLights.toString()}`;
            content.id = tag;
            content.tag = tag;
        }
        if (type === 'model') {
            const nbModels = getModels().length + 1;
            const tag = `${type} ${nbModels.toString()}`;
            content.tag = tag;
            content.id = tag;
        }
    }
    return _contentsManager.addNewContent(content.type, content, typedata);
};

const addProjectContentEditor = (contents: any[]) => {
    contents.forEach((contentEditor) => {
        addContent(contentEditor.contentdata, contentEditor.typedata);
    });
};

const addCameraAndEnv = (project: any) => {
    _environment.checkOption(project.environment);
    _pipeline.checkOption(project.pipeline);
    _camera.setOption(project.camera);
};

const addPointOfViews = (povs: any[]) => {
    _pointofviewsManager.setPointofviews(povs);
};

export const createProject = (project: any, callback: (result: boolean) => void): void => {
    jsonConverter.clean(project);
    addCameraAndEnv(project);
    addProjectContentEditor(project.contents);
    addPointOfViews(project.pointofviews);
    _system.toolMaterial.materialList = project.materials;
    startRender(callback);
};

export const loadProjectJson = (projectId: string, callback: (json) => void): void => {
    if (env.saving) {
        contextProject.work(projectId, (project) => {
            if (!project) callback(false);
            else if (project.success !== undefined) callback(false);
            else {
                callback(project);
            }
        });
    } else {
        contextProject.projectFound(LOCAL_JSON);
        callback(LOCAL_JSON);
    }
};
